<div class="analysis-toolbar">
  <div class="analysis-toolbar__search">
    <app-search
      [isLoading]="isLoading"
      [realTime]="true"
      [placeholder]="'Buscar empresa ou CNPJ'"
      (sendSearch)="searchChange.emit($event)"></app-search>
  </div>

  <div class="analysis-toolbar__right">
    <span class="analysis-toolbar__count">{{ companiesCount }} {{ companiesLabel }}</span>

    <div class="analysis-toolbar__switch" role="group" aria-label="Alternar visualização">
      <button
        type="button"
        class="analysis-toolbar__switch__option"
        [class.analysis-toolbar__switch__option--active]="viewMode === 'table'"
        [attr.aria-pressed]="viewMode === 'table'"
        (click)="selectView('table')">
        Tabela
      </button>
      <button
        type="button"
        class="analysis-toolbar__switch__option"
        [class.analysis-toolbar__switch__option--active]="viewMode === 'cards'"
        [attr.aria-pressed]="viewMode === 'cards'"
        (click)="selectView('cards')">
        Cards
      </button>
    </div>
  </div>
</div>
